"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModelsGroupId = void 0;
const react_cirrus_1 = require("@yanzi/react-cirrus");
const react_oauth_1 = require("@yanzi/react-oauth");
const react_query_1 = require("react-query");
const useModelsQuery_1 = require("./useModelsQuery");
function useModelsGroupId(accountNumber) {
    var _a;
    const { host } = react_cirrus_1.useCirrus();
    const sessionId = react_cirrus_1.useCirrusSessionId();
    const { accessToken } = react_oauth_1.useOAuth();
    const [apiUrl] = useModelsQuery_1.useApiUrlState(useModelsQuery_1.DEFAULT_API_URL);
    const { data } = react_query_1.useQuery(['models-group-id', accountNumber, host, sessionId], () => __awaiter(this, void 0, void 0, function* () {
        const token = yield accessToken.get();
        const res = yield fetch(`${apiUrl}/groups?cirrusId=${accountNumber}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'X-Cirrus-Host': host,
                'X-Cirrus-Session': sessionId,
            },
        });
        return res.json();
    }), { enabled: !!accessToken && !!sessionId && !!accountNumber });
    return (_a = data === null || data === void 0 ? void 0 : data.id) !== null && _a !== void 0 ? _a : null;
}
exports.useModelsGroupId = useModelsGroupId;
//# sourceMappingURL=useModelsGroupId.js.map